import { useLocation } from "wouter";
import { locationsArray, screens } from "../constants/constants";
import { OnCurtainStart } from "../types/types";
import { Screen404 } from "./Screen404";
import { ScreenLanding } from "./ScreenLanding/ScreenLanding";
import { ScreenLoadingAssets } from "./ScreenLoadingAssets";
import { ScreenMedia } from "./ScreenMedia";
import { ScreenMenu } from "./ScreenMenu/ScreenMenu";
import { ScreenPerformance } from "./ScreenPerformance";
import { ScreenPreorder } from "./ScreenPreorder";
import { ScreenProduct } from "./ScreenProduct";

export const Screens = ({
  screen,
  isCurtainActive,
  isCurtainIntro,
  onCurtainStart,
}: {
  screen: string;
  isCurtainActive: boolean;
  isCurtainIntro: boolean;
  onCurtainStart: OnCurtainStart;
}) => {
  const [location] = useLocation();

  return (
    <>
      {screen === screens.loading && (
        <ScreenLoadingAssets
          {...{
            onCurtainStart,
          }}
        />
      )}
      {screen === screens.landing && (
        <ScreenLanding
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {screen === screens.menu && (
        <ScreenMenu
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {screen === screens.product && (
        <ScreenProduct
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {screen === screens.performance && (
        <ScreenPerformance
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {screen === screens.media && (
        <ScreenMedia
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {screen === screens.preorder && (
        <ScreenPreorder
          {...{
            isCurtainActive,
            isCurtainIntro,
            onCurtainStart,
          }}
        />
      )}

      {!locationsArray.includes(location) && (
        <Screen404
          {...{
            currentScreen: !locationsArray.includes(location),
          }}
        />
      )}
    </>
  );
};
